import * as React from "react";
import { TableCell, TableRow } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { BaseTableCell, SimpleTableRow } from "../../interfaces";

interface Props {
  tableData: SimpleTableRow[];
  secondaryTableData: SimpleTableRow[][];
}

const useClasses = makeStyles({
  rowOnClick: {
    "cursor": "pointer",
    "& td": {
      fontWeight: "bold",
    },
    "&:hover td, &:focus-visible td": {
      backgroundColor: "#C6EDF2",
    },
  },
  tableCell: {
    maxWidth: 200,
  },
  tableCellCheck: {
    "&.MuiTableCell-paddingCheckbox": {
      width: "fit-content",
      textAlign: "left",
    },
  },
});

export default function MultiTableBody({
  tableData,
  secondaryTableData,
}: Props) {
  const classes = useClasses();
  return (
    <>
      {tableData.map((tableCell: SimpleTableRow, index: number) => {
        return (
          <React.Fragment key={`${index}`}>
            <TableRow
              id={`simple-table-row-${index}`}
              hover
              tabIndex={0}
              onKeyPress={tableCell.rowOnClick}
              onClick={tableCell.rowOnClick}
              style={{ backgroundColor: "#ced6e3" }}
              className={tableCell.rowOnClick ? classes.rowOnClick : ""}
            >
              {Object.keys(tableCell).map((key: string, cellIndex: number) => {
                const value = (tableCell[key] as BaseTableCell).value;
                return key !== "rowOnClick" ? (
                  <TableCell
                    className={classes.tableCell}
                    id={`${key}-${index}`}
                    key={`${key}`}
                    style={(tableCell[key] as BaseTableCell).styles}
                  >
                    {value}
                  </TableCell>
                ) : (
                  undefined
                );
              })}
            </TableRow>
            {secondaryTableData[index] &&
              secondaryTableData[index].map(
                (tableCell: SimpleTableRow, secondaryIndex: number) => {
                  return (
                    <TableRow
                      id={`simple-tabl-secondary-row-${index}-${secondaryIndex}`}
                      key={`${index}-${secondaryIndex}`}
                      hover
                      tabIndex={0}
                    >
                      {Object.keys(tableCell).map(
                        (key: string, cellIndex: number) => {
                          const value = (tableCell[key] as BaseTableCell).value;
                          return (
                            <TableCell
                              className={classes.tableCell}
                              id={`${key}-${index}`}
                              key={`${key}-${cellIndex}`}
                              style={(tableCell[key] as BaseTableCell).styles}
                            >
                              {value}
                            </TableCell>
                          );
                        },
                      )}
                    </TableRow>
                  );
                },
              )}
          </React.Fragment>
        );
      })}
    </>
  );
}
